<template>
  <v-container grid-list-lg fluid>
    <v-row row wrap>
      <v-col cols="12" sm="12" md="4">
        <v-row>

          <v-col cols="12" sm="12">
            <v-card outlined>
              <v-toolbar dense flat color="grey lighten-3">
                <v-toolbar-title>
                  Note
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="checkRightStatus(36)" small color="info" dark class="mr-2" @click="updateNote()" fab text>
                  <v-icon>save</v-icon>
                </v-btn>
                <div v-if="checkRightStatus(37)">
                  <span class="mr-2">Alert</span>
                  <toggle-button @change="updateAlert" :labels="true" v-if="getCustomer" color="red"
                    v-model="getCustomer.alert" :value="getCustomer.alert" :sync="true"></toggle-button>
                </div>
              </v-toolbar>
              <v-card-text>
                <v-textarea v-model="note" outlined hide-details label="Customer Note"></v-textarea>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="12">
            <v-card outlined>
              <v-card-text>
                <div class="text-center">
                  <span class="mr-2">Paying Cash</span>
                  <toggle-button @change="updatePayingCash" :labels="true" v-if="getCustomer" color="green"
                    v-model="getCustomer.payingCash" :value="getCustomer.payingCash" :sync="true"></toggle-button>

                </div>
              </v-card-text>
            </v-card>
          </v-col>


          <v-col cols="12" sm="12">

            <PaymentMethod ref="paymentMethodComponent" type="customer" :customer="getCustomer" />


            <!-- <v-select dense outlined :items="MerchantAccount" v-model="selectedMerchant" return-object item-text="name"
              label="Select Default Account"></v-select> -->


          </v-col>

          <!-- <v-col cols="12" sm="12">

            <v-card outlined>
              <v-toolbar dense flat color="grey lighten-3">
                <v-toolbar-title>
                  Stripe
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn fab x-small dark color="pink" @click="editStripe"><v-icon>mdi-pencil-outline</v-icon></v-btn>
              </v-toolbar>
              <v-card-text v-if="!getCustomer.stripeId">
                <div class="text-center">
                  <v-btn color="info" @click="attachStripeId" block>Attach Stripe ID</v-btn>
                </div>
              </v-card-text>
              <v-card-text v-else>
                <div class="text-center">
                  {{ getCustomer.stripeId }}
                </div>
              </v-card-text>
            </v-card>
          </v-col> -->
          <!-- <v-col cols="12" sm="12" v-if="getCustomer.mohidId">
            <v-card outlined>
              <v-toolbar dense flat color="grey lighten-3">
                <v-toolbar-title>
                  Mohid
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <div class="text-center">
                  <a :href="`https://us.mohid.co/ny/newyork/muhammadimasjid/masjid/admin/donation/consolidation/${getCustomer.mohidId}`"
                    target="_blank">View Consolidation</a>
                </div>

              </v-card-text>
            </v-card>
          </v-col> -->

          <!-- <v-col cols="12" sm="12" v-if="!getCustomer.mohidId">
            <v-card outlined>
              <v-toolbar dense flat color="grey lighten-3">
                <v-toolbar-title>
                  Mohid
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <div class="text-center">
                  <v-btn color="brown darken-1" dark block @click="attachMohid">Attach Mohid ID</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col> -->
          <!-- <v-col cols="12" sm="12">
            <PaymentPie :CustomerId="getCustomer.id"/>
          </v-col> -->
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="8">
        <Comment :RelationId="getCustomer" :TypeId="1" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import customerService from "../service";
import stripeService from "@/modules/Stripe/service.js";
const Comment = () => import("@/modules/Comment/components/List");

import PaymentMethod from "@/modules/PaymentMethod/components/List.vue"
// import merchantService from "@/modules/Merchant/service.js";


// import SaleRep from "@/modules/User/components/AutoComplete.vue"
// import PaymentPie from "@/modules/Payment/Chart/PaymentMethodPie";

export default {
  name: "customer-dashbaord",
  data() {
    return {
      stripeCustomer: null,
      isLoading: false,
      loading: false,
      note: null,
      selectedUser: null,
    };
  },
  computed: {
    ...mapGetters("customer", ["getCustomer"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus", 'currentBusiness']),
  },
  components: {
    // CreditCard,
    Comment,
    // CreditCard,
    PaymentMethod,
    // SaleRep
  },
  watch: {

    getCustomer: {
      immediate: true,
      async handler(val) {
        
        this.note = val.note;
        
        if (this.$refs.paymentMethodComponent) {
          this.$refs.paymentMethodComponent.reload();
        }
      },
    },
  },
  methods: {
    ...mapActions("customer", ["setCustomer"]),
    async reload() {
      this.isLoading = true
      await this.setCustomer(this.getCustomer.id)
      // await this.getDonationCategoryList()
      // this.getCard()

    },
    markDefaultCard(card) {
      stripeService.changeDefaultCard({
        customer_id: this.getCustomer.stripeId,
        default_source: card.id
      }).then(result => {
        console.log('result', result)
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "success",
            title: "Card Marked Default",
          });
        this.reload()
      })
    },

    // getCard() {
    //   if (this.getCustomer && this.getCustomer.stripeId) {
    //     stripeService.getCustomerById({ customer_id: this.getCustomer.stripeId })
    //       .then((response) => {

    //         this.stripeCustomer = response.data
    //         return stripeService.getAllCard({ customer_id: this.getCustomer.stripeId })
    //           .then((response) => {
    //             console.log('card list', response)
    //             this.cards = response.data
    //             this.isLoading = false
    //           })
    //       })

    //   }
    // },
    // editStripe() {
    //   this.$swal.fire({
    //     title: 'Enter New Stipe ID',
    //     input: 'text',
    //     inputAttributes: {
    //       autocapitalize: 'off'
    //     },
    //     showCancelButton: true,
    //     confirmButtonText: 'Save',
    //     showLoaderOnConfirm: true,
    //     preConfirm: (value) => {
    //       return stripeService.getCustomerById({ customer_id: value })
    //         .then(() => {
    //           // console.log('dklfjdlkf', response)
    //           return customerService.update(this.getCustomer.id, { stripeId: value }).then(response => {

    //             this.getCard()
    //             return response.data
    //           })
    //         })
    //         .catch(error => {
    //           console.log('error', error)
    //           this.$swal.showValidationMessage(
    //             `Request failed: ${error.data.message}`
    //           )
    //         })
    //       // return fetch(`//api.github.com/users/${login}`)
    //       //   .then(response => {
    //       //     if (!response.ok) {
    //       //       throw new Error(response.statusText)
    //       //     }
    //       //     return response.json()
    //       //   })
    //       //   .catch(error => {
    //       //     this.$swal.showValidationMessage(
    //       //       `Request failed: ${error}`
    //       //     )
    //       //   })
    //     },
    //     allowOutsideClick: () => !this.$swal.isLoading()
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.$swal.fire({
    //         title: `${result.value.login}'s avatar`,
    //         imageUrl: result.value.avatar_url
    //       })
    //     }
    //   })
    // },
    // attachStripeId() {
    //   this.$swal.fire({
    //     title: 'Enter Stripe ID',
    //     input: 'text',
    //     inputAttributes: {
    //       autocapitalize: 'off'
    //     },
    //     showCancelButton: true,
    //     confirmButtonText: 'Submit',
    //     showLoaderOnConfirm: true,
    //     preConfirm: (stripeId) => {
    //       console.log('config', stripeId)
    //       customerService.update(this.getCustomer.id, { stripeId: stripeId }).then(response => {
    //         console.log('response', response)
    //         if (!response.code === '000000') {
    //           throw new Error(response.statusText)
    //         }

    //         this.getCustomerData()
    //         return response
    //       })
    //         .catch(error => {
    //           this.$swal.showValidationMessage(
    //             `Request failed: ${error}`
    //           )
    //         })
    //     },
    //     allowOutsideClick: () => !this.$swal.isLoading()
    //   }).then((result) => {
    //     console.log('resultresultresult', result)
    //     if (result.value) {
    //       this.$swal
    //         .mixin({
    //           toast: true,
    //           position: "top-end",
    //           showConfirmButton: false,
    //           timer: 3000,
    //         })
    //         .fire({
    //           icon: "success",
    //           title: "Stripe Id Set",
    //         });

    //     }
    //   })
    // },
    // attachMohid() {
    //   this.$swal.fire({
    //     title: 'Enter Mohid ID',
    //     input: 'number',
    //     inputAttributes: {
    //       autocapitalize: 'off'
    //     },
    //     showCancelButton: true,
    //     confirmButtonText: 'Submit',
    //     showLoaderOnConfirm: true,
    //     preConfirm: (mohidId) => {
    //       console.log('config', mohidId)
    //       customerService.update(this.getCustomer.id, { mohidId: mohidId }).then(response => {
    //         console.log('response', response)
    //         if (!response.code === '000000') {
    //           throw new Error(response.statusText)
    //         }

    //         this.getCustomerData()
    //         return response
    //       })
    //         .catch(error => {
    //           this.$swal.showValidationMessage(
    //             `Request failed: ${error}`
    //           )
    //         })
    //     },
    //     allowOutsideClick: () => !this.$swal.isLoading()
    //   }).then((result) => {
    //     console.log('resultresultresult', result)
    //     if (result.value) {
    //       this.$swal
    //         .mixin({
    //           toast: true,
    //           position: "top-end",
    //           showConfirmButton: false,
    //           timer: 3000,
    //         })
    //         .fire({
    //           icon: "success",
    //           title: "Mohid Id Set",
    //         });

    //     }
    //   })
    // },
    async getCustomerData() {

      this.$Progress.start();

      await this.setCustomer(this.getCustomer.id).then(result => {
        console.log('result', result)
        this.$forceUpdate();
      }).catch(err => {
        console.log('err', err)
      })

      // this.setPageTitle(this.getCustomer.name);
      // console.log("getCustomer", this.getCustomer);
      this.$Progress.finish();
    },
    test(val) {
      console.log(val)
    },
    updateNote() {
      let data = {
        note: this.note,
      };
      this.updateCustomer(data);
    },
    updateAlert(val) {
      let data = {
        alert: val.value,
      };
      this.updateCustomer(data);
    },
    updatePayingCash(val) {
      let data = {
        payingCash: val.value,
      };
      this.updateCustomer(data);
    },
    updateSaleman(val) {
      let data = {
        SalesRepUserId: val.id
      };
      this.updateCustomer(data);
    },
    updateCustomer(data) {
      return customerService.update(this.getCustomer.id, data).then((result) => {
        console.log('result', result)
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "success",
            title: "Update Successfully",
          });
        this.setCustomer(this.getCustomer.id);
      });
    },
  },
};
</script>
